"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FunctionalGlobe2 = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FunctionalGlobe2 = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: props.strokeWidth || 2,
  d: "M15.062 2.747a9.766 9.766 0 0 0-3.059-.488c-3.8 0-7.104 2.173-8.796 5.373m11.855-4.885c4.027 1.326 6.943 5.199 6.943 9.77 0 2.25-.707 4.332-1.905 6.023M15.06 2.747 13.433 5.19h-1.905l1.429 2.442h2.381l.953 1.954-2.382 1.465h-2.857l-1.43 1.954 1.335 1.71m9.143 3.825c-1.817 2.566-4.767 4.234-8.096 4.234a9.77 9.77 0 0 1-2.857-.424m10.953-3.81-1.904-1.627H16.29l-.953.977h-1.905l-1.143-1.466m0 0-2.19 2.443-.953 3.483m3.143-5.926-1.333-1.71m-1.81 7.636c-4.132-1.261-7.144-5.187-7.144-9.833 0-1.769.436-3.433 1.205-4.885m7.749 7.083-2.287.732-2.38-2.442v-3.42L3.206 7.633"
}));
exports.FunctionalGlobe2 = FunctionalGlobe2;
FunctionalGlobe2.displayName = "FunctionalGlobe2";